document.addEventListener("DOMContentLoaded", async () => {
    if (typeof google === "undefined" || typeof google.maps === "undefined") {
        console.error("Google Maps API did not load.");
        return;
    }

    try {
        const { Map } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        document.querySelectorAll(".communities-map-block").forEach((block) => {
            const communities = JSON.parse(block.dataset.communities || "[]");
            const mapContainer = block.querySelector(".map-container");
            const iconBlue = block.dataset.iconBlue;
            const iconOrange = block.dataset.iconOrange;

            if (!mapContainer) return;

            const defaultCenter = communities.length
                ? { lat: parseFloat(communities[0].lat), lng: parseFloat(communities[0].lng) }
                : { lat: 39.8283, lng: -98.5795 };

            const initialZoom = communities.length > 1 ? 10 : 15;

            const map = new Map(mapContainer, {
                center: defaultCenter,
                zoom: initialZoom,
                zoomControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: true,
                gestureHandling: "cooperative",
                mapId: "66b205ff503f486ca69237c1"
            });

            if (communities.length === 0) return;

            const bounds = new google.maps.LatLngBounds();
            const infoWindow = new google.maps.InfoWindow({
                pixelOffset: new google.maps.Size(0, -38),
                disableAutoPan: true
            });

            map.addListener("dragstart", () => {
                infoWindow.close();
            });

            communities.forEach((community) => {
                const lat = parseFloat(community.lat);
                const lng = parseFloat(community.lng);
                if (isNaN(lat) || isNaN(lng)) return;

                const markerImg = document.createElement("img");
                const iconUrl = (community.icon === "orange" && iconOrange) ? iconOrange : iconBlue;

                markerImg.src = iconUrl;
                markerImg.style.width = "32px";
                markerImg.style.height = "38px";
                markerImg.style.cursor = "pointer";

                const marker = new AdvancedMarkerElement({
                    map: map,
                    position: { lat, lng },
                    title: community.title,
                    content: markerImg,
                    gmpClickable: true
                });

                const content = `
                    <div style="padding: 12px; min-width: 220px; font-family: system-ui, sans-serif;">
                        <h3 style="margin: 0 0 10px 0; color: #000;">${community.title}</h3>
                        ${community.description ? `<p style="margin: 0 0 12px 0; color: #555;">${community.description}</p>` : ""}
                        ${community.url ? `<a href="${community.url}" target="_self" style="color: #236d9f; text-decoration: none;">View Details →</a>` : ""}
                    </div>
                `;

                marker.addEventListener("gmp-click", () => {
                    infoWindow.close();
                    infoWindow.setContent(content);
                    infoWindow.open({
                        map: map,
                        anchor: marker,
                        shouldFocus: false
                    });

                    setTimeout(() => {
                        const projection = map.getProjection();
                        if (!projection) return;

                        const pos = marker.position;
                        const point = projection.fromLatLngToPoint(pos);
                        const scale = 1 << map.getZoom();
                        const desiredOffset = 180;

                        const newPoint = new google.maps.Point(
                            point.x,
                            point.y - (desiredOffset / scale)
                        );

                        const newCenter = projection.fromPointToLatLng(newPoint);
                        if (newCenter) map.panTo(newCenter);
                    }, 280);
                });

                bounds.extend({ lat, lng });
            });

            if (communities.length > 1) {
                map.fitBounds(bounds, {
                    padding: { top: 90, right: 60, bottom: 60, left: 60 }
                });

                setTimeout(() => {
                    let currentZoom = map.getZoom();
                    if (currentZoom > 14) {
                        map.setZoom(14);
                    } else if (currentZoom > 12) {
                        map.setZoom(currentZoom - 1);
                    }
                }, 800);
            }
        });

    } catch (err) {
        console.error("Google Maps initialization error:", err);
    }
});